import styled from "styled-components";

const checkColor = (primaryColor, checkoutColor) => {
  if (checkoutColor.toLowerCase() === "#ffffff") {
    if (primaryColor.toLowerCase() === "#ffffff") {
      return "#303030";
    } else {
      return primaryColor;
    }
  } else {
    return checkoutColor;
  }
};

export const CheckboxInput = styled.input`
  display: flex;
  align-items: center;
  justify-content: center;

  min-width: 20px;
  min-height: 20px;

  appearance: none;
  border-radius: 0.25rem;
  transition: ease 300ms;
  border: 1.5px solid #ffffff;
  cursor: pointer;

  position: relative;

  &::before {
    display: flex;

    content: "";
    min-width: 20px;
    min-height: 20px;

    opacity: 0;
    border-radius: 0.25rem;
    transition: ease-in 200ms;

    background-size: contain;
    background-position: center;
    background-color: #ffffff;

    background-image: ${(props) => {
      const primaryColor = props.theme?.colors?.primary;
      const checkoutPrimaryColor =
        props.theme?.checkoutStepsOffers?.checkoutPrimaryColor;
      const color = checkColor(primaryColor, checkoutPrimaryColor).replace(
        "#",
        "",
      );
      return `url("data:image/svg+xml,%3Csvg width='12' height='12' viewBox='0 0 12 12' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M10 3L4.5 8.5L2 6' stroke='%23${color}' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E%0A")`;
    }};

    position: absolute;
  }

  &:checked::before {
    opacity: 1;
  }
`;

export const CheckboxContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;

  width: 100%;

  gap: 0.75rem;
`;

export const LabelContainer = styled.div`
  display: flex;
  width: 100%;

  justify-content: space-between;

  cursor: pointer;

  @media (max-width: 1090px) {
    flex-wrap: wrap;
  }
`;

export const Label = styled.label`
  font-weight: 600;
  line-height: 1.219rem;
  color: #ffffff;

  cursor: pointer;
`;

export const LabelPrice = styled.label`
  font-size: 0.813rem;
  font-weight: 700;
  line-height: 1.219rem;
  color: #ffffff;

  cursor: pointer;

  align-self: flex-end;
`;
